export function createRoutes() {
  return [
    {
      path: 'schedules',
      component: () => import(/* webpackChunkName: "ScheduleChrome" */ './ScheduleChrome.vue'),
      children: [
        {
          path: '/',
          component: () => import(/* webpackChunkName: "ScheduleDaily" */ './ScheduleDaily.vue'),
        },
        {
          path: ':scheduleYear/:scheduleMonth/:scheduleDate',
          name: 'ScheduleDaily',
          component: () => import(/* webpackChunkName: "ScheduleDaily" */ './ScheduleDaily.vue'),
        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
